"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTestStorage = void 0;
var createTestStorage = function (map) {
    if (map === void 0) { map = {}; }
    var storage = {
        get: function (key) { return Promise.resolve(map[key]); },
        set: function (key, value) {
            map[key] = value;
            return Promise.resolve(map[key]);
        }
    };
    return storage;
};
exports.createTestStorage = createTestStorage;
//# sourceMappingURL=index.js.map